
import {  showAllZoomLevel } from '../const';

export const loadMapLayers = (
  map: mapboxgl.Map,
  geoJson: GeoJSON.FeatureCollection<GeoJSON.Geometry>,
  useClustering: boolean,
  zoomLevel: number,
  // accuracySourceId : string
) => {
  if (useClustering) {
    // Add GeoJSON source for clustering
    map.addSource('markers', {
      type: 'geojson',
      //@ts-ignore
      data: geoJson,
      cluster: true,
      clusterMaxZoom: 7,
      clusterRadius: 50,
    });

    // Cluster layer
    map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'markers',
      filter: ['has', 'point_count'],
      paint: {
        // Style for clusters
        'circle-color': [
          'step',
          ['get', 'point_count'],
          '#C4B5FA', // Color for 1-2 points
          10,
          '#C4B5FA', // Color for 10-20 points
          20,
          '#C4B5FA', // Color for 20+ points
        ],
        'circle-radius': [
          'step',
          ['get', 'point_count'],
          20, // Size for 1-2 points
          10,
          30, // Size for 10-20 points
          20,
          40, // Size for 20+ points
        ],
        'circle-opacity': 0.5,
      },
    });

    // Cluster count layer
    map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'markers',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': ['get', 'point_count_abbreviated'],
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
      },
    });


    // Set up click event for clusters
    map.on('click', 'clusters', (e) => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['clusters'],
      });

      if (!(features ?? []).length || !features || !map) return;

      const clusterId = features[0].properties?.cluster_id;

      // Use getClusterExpansionZoom to get the zoom level required to expand the cluster
      const source: mapboxgl.GeoJSONSource = map.getSource(
        'markers',
      ) as mapboxgl.GeoJSONSource;

      source.getClusterExpansionZoom(clusterId, (err, zoom) => {
        if (err) {
          console.error('Error getting cluster expansion zoom:', err);
          return;
        }

        // Ensure the feature is a point and has coordinates
        const coordinates =
          features[0].geometry.type === 'Point'
            ? (features[0].geometry.coordinates as [number, number])
            : undefined;

        if (coordinates && map) {
          // Zoom into the coordinates
          map.easeTo({
            center: coordinates,
            zoom: map.getZoom() + 2,
          });
        }
      });
    });
  } else {
    map.addSource('markers', {
      type: 'geojson',
      //@ts-ignore
      data: geoJson,
      cluster: true,
      clusterMaxZoom: showAllZoomLevel,
      clusterRadius: 150,
    });

    // Cluster layer
    map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'markers',
      filter: ['has', 'point_count'],
      paint: {
        // Style for clusters
        'circle-color': [
          'step',
          ['get', 'point_count'],
          '#CDC2FC', // Color for 1-2 points
          10,
          '#CDC2FC', // Color for 10-20 points
          20,
          '#CDC2FC', // Color for 20+ points
        ],
        'circle-radius': [
          'step',
          ['get', 'point_count'],
          20, // Size for 1-2 points
          10,
          30, // Size for 10-20 points
          20,
          40, // Size for 20+ points
        ],
        'circle-opacity': 0,
      },
    });
  }

  

  // map.addSource(accuracySourceId, {
  //   type: "geojson",
  //   data: {
  //     type: "FeatureCollection",
  //     features: [],
  //   },
  // });

  // map.addLayer({
  //   id: "accuracy-circle",
  //   type: "fill",
  //   source: accuracySourceId,
  //   paint: {
  //     "fill-color": "rgba(0, 122, 255, 0.2)",
  //     "fill-opacity": 0.5,
  //   },
  // }
  // );

  // console.log("Map loaded and accuracy circle source added.");
};
